import script from "./OfSignupSessionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OfSignupSessionForm.vue?vue&type=script&setup=true&lang=js"

import "./OfSignupSessionForm.vue?vue&type=style&index=0&id=5d103add&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d103add"]])

export default __exports__